<template>
  <main class="form_modal">
    <loader v-if="loader"></loader>
    <span class="form_modal__background">
      <span class="form_modal__background__header"></span>
      <span class="form_modal__background__image" :style="{ backgroundImage: `url('${image}')` }"></span>
      <span v-if="!success" class="form_modal__actions">
        <span v-if="!success" style="position: absolute; font-size: 10px; top: 4px">
          Al hacer click en "enviar" aceptas <a href="https://fuseaccess.com/politica-de-privacidad/" target="_blank">términos y
            condiciones</a> del Edificio
        </span>
        <button v-if="!success && mail.user_photo" class="w-full form_modal__button form_modal__button--success mb-2 mt-1"
          :class="{ 'form_modal__button--disabled': formIsInError, 'close_button': formIsInError }"
          @click="formIsInError ? '' : requestAccess()">
          Enviar
        </button>
        <button v-if="!success && !mail.user_photo" class="w-full form_modal__button mb-2 mt-1"
          @click="takePhoto">
          Tomar Foto
        </button>
      </span>
      <img v-if="success" class="form_modal__company_logo"
          src="https://fusepongsolutions.s3.us-west-2.amazonaws.com/Logofuseaccess.png" alt="">
    </span>
    <article v-if="!success" class="form_modal__fair access_requirement">
      <section class="form_modal__fair__container_video fair_invitation fair_invitation_right">
        <section class="access_requirement__virtual_guard">
          <!-- <img src="" alt=""> -->

        </section>
        <div class="fair_invitation__content">
          <div class="fair_invitation__content--right">
            <h3 style="margin-bottom: 1rem; border-bottom: solid 1px #3c3c3c; padding-bottom: 0.5rem;">{{ company_name }}</h3>
            <div v-show="show_location" style="position: relative; display: flex; align-items: center;">
              <select placeholder="Selecciona Apartamento" v-model="mail.sublocation_id"
                @change="validateVehicleTypeLocation()">
                <option :value="null" disabled selected>Selecciona Apartamento</option>
                <option :value="location.id" v-for="(location, index) in locations" :key="location.id">{{ location.name
                  }}</option>
              </select>
              <span style="color: #727272; transform: rotate(90deg); display: inline-block; position: absolute; right: 1.4rem; top: 4px; font-size: 28px;">></span>
            </div>
            <div>
              <input v-model="mail.name" type="text" name="name" placeholder="Escribe tu nombre completo"
                v-validate="'required'">
            </div>
            <div>
              <input v-model="mail.phone" type="number" name="phone" placeholder="Escribe tu número de Celular"
                v-validate="'required|max:14'">
            </div>

            <div class="" style="display: flex; align-items: center; justify-content: space-between">
              <div class="form_modal__row_container">
                <canvas ref="canvas" style="display: none;" />
                <video v-if="!mail.user_photo" ref="video" autoplay playsinline
                  style="width: 100%; aspect-ratio: 3/4; transform: scaleX(-1)" />
                <span v-else style="position: relative;">
                  <img style="width: 100%; aspect-ratio: 3/4; transform: scaleX(-1)" :src="mail.user_photo">
                  <span @click="removePhoto" style="position: absolute; right: -10px; top: -10px; display: block; width: 28px; height: 28px; background-color: white; padding: 0.2rem; border-radius: 50%;">
                    <remove-icon></remove-icon>
                  </span>
                </span>
                <img style="width: 60%" src="https://fusepongsolutions.s3.us-west-2.amazonaws.com/Logofuseaccess.png" alt="">
              </div>
            </div>

          </div>
        </div>
      </section>
    </article>
    <article v-else class="form_modal__fair">
      <h3>{{ company_name }}</h3>
      <section class="form_modal__success">
        <div class="form_modal__success__header">
          <h4>Listo!</h4>
          <success-icon />
        </div>
        <div style="padding: 0 1rem 1rem 1rem;">
          <p style="color: #64b848; padding-bottom: 0.8rem; border-bottom: solid 1px #3c3c3c; margin-bottom: 0.8rem; font-size: 26px;">En
            breve te atenderán!</p>
          <p class="mb-2">Ya hemos notificado al</p>
          <h3 class="mb-2">{{locations.find(item => item.id === mail.sublocation_id).name}}</h3>
          <p class="mb-2">que te encuentras en su edificio</p>
          <p class="form_modal__message"><strong>¡Gracias!</strong></p>
        </div>
      </section>
      <button class="form_modal__button_green mt-c" @click="close">Cerrar</button>
    </article>
  </main>

</template>
<script>
import Loader from '@/components/shared/Loader.vue'
import VirtualGuardLogo from '@/components/shared/VirtualGuardLogo.vue'
import ProfileIcon from "@/components/shared/icons/ProfileIcon.vue";
import SuccessIcon from "@/components/shared/icons/SuccessIcon.vue";
import headerImage from '@/assets/img/header.jpeg';
import RemoveIcon from '../../shared/icons/RemoveIcon.vue';

export default {
  data() {
    return {
      image: headerImage,
      show_errors: false,
      loader: true,
      mail: {
        rut: '',
        vehicle_type: '',
        plate_number: '',
        name: '',
        email: '',
        phone: '',
        location_id: null,
        document_photo: null,
        user_photo: null,
        sublocation_id: '',
        virtual_guard: true
      },
      success: false,
      fieldError: '',
      errorOpening: false,
      errorEnding: false,
      spacesInError: false,
      validator: '',
      selfie_image: null,
      document_image: null,
      current_company: null,
      locations: [
        { location_id: 1, location_name: "Torre 1", sublocations: [{ sublocation_id: 1, sublocation_name: "Apto 101" }, { sublocation_id: 2, sublocation_name: "Apto 102" }] },
        { location_id: 2, location_name: "Torre 2", sublocations: [{ sublocation_id: 1, sublocation_name: "Apto 201" }, { sublocation_id: 2, sublocation_name: "Apto 202" }] }],
      current_location: null,
      current_sublocation: null,
      active_sublocations: false,
      open_access_request: false,
      show_location: true,
      invalid_email: false,
      vehicular_type_location: false,
      company_invitation_form_vehicle_data: false,
      company_name: 'Compañía no seleccionada',
      stream: null,
      photoDataUrl: null,
    }
  },
  mounted() {
    this.current_company = this.$route.query.id ? this.$route.query.id : null
    this.mail.location_id = this.$route.query.location_id ? Number(this.$route.query.location_id) : null
    this.mail.sublocation_id = this.$route.query.sublocation_id ? Number(this.$route.query.sublocation_id) : null
    // if (this.$route.query.location_id && this.$route.query.location_id) {
    //   this.show_location = false
    // }

    // if (this.current_company != null && (this.mail.location_id == null || this.mail.sublocation_id == null)) {
    //   this.open_access_request = false
    // }
    this.findLocationsByCompany();
    this.startCamera();
  },
  watch: {
    current_location() {
      this.active_sublocations = true
      // this.mail.location_id = this.current_location
    },
    current_sublocation() {
      // this.mail.sublocation_id = this.current_sublocation
    },
    'mail.plate_number'(newValue) {
      this.mail.plate_number = this.mail.plate_number.toUpperCase();
    }
  },
  components: {
    'loader': Loader,
    'virtual-guard-logo': VirtualGuardLogo,
    'profile-icon': ProfileIcon,
    'success-icon': SuccessIcon,
    'remove-icon': RemoveIcon,
  },
  computed: {
    formIsInError() {
      let ans = false
      let fields = []
      if (this.mail.name.length === 0) {
        fields.push("'Ingresa nombre'");
      }
      // if(this.mail.email.length==0){
      //   fields.push("'Ingresa correo electrónico'");
      // }
      if (this.mail.phone.length === 0) {
        fields.push("'Ingresa telefono'")
      }
      if (!this.mail.sublocation_id) {
        fields.push("'Selecciona el apartamento al que te diriges'")
      }

      if (!this.mail.user_photo) {
        fields.push("'Sube una selfie'")
      }

      if (fields.length > 0) {
        if (fields.length === 2) {
          this.fieldError = fields.join(" y ")
        } else {
          this.fieldError = fields.join(" , ")
        }
        this.$validator.validateAll()
        ans = true
      } else {
        this.fieldError = ""
      }
      return ans
    },
  },
  methods: {
    findLocationsByCompany() {
      this.loader = true
      try {
        this.$http.get('app/company/find_locations_by_company/' + this.current_company)
          .then(function (response) {
            this.company_name = response.body.company_info.name;
            if (this.mail.location_id === null && this.mail.sublocation_id === null) {
              const locations = [];
              response.body.ans.forEach(loc => {
                locations.push(...loc.sublocations.map(item => ({ id: item.sublocation_id, name: item.sublocation_name })));
                this.locations = locations;
              });
              this.locations
            } else if(this.mail.location_id !== null) {
              var current_location = response.body.ans.find((loc) => loc.location_id === this.mail.location_id);
              const locations = [];
               locations.push(...current_location.sublocations.map(item => ({ id: item.sublocation_id, name: item.sublocation_name })));
               this.locations = locations;
              // if (current_location !== undefined) {
              //   this.vehicular_type_location = current_location.vehicular_type
              // }
            }
            this.loader = false
            this.company_invitation_form_vehicle_data = response.body.company_info.invitations_form_vehicle_data
          }, function (response) {
            this.loader = false
          })
      } catch (e) {
        this.loader = false
      }
    },
    async createUserImage(event) {
      if (event.target.files.length > 0) {
        let vm = this
        let user_image = event.target.files[0]
        let extension = event.target.files[0].type.split('/')[1];

        if (extension !== "jpg" && extension !== "jpeg") {
          alert('Solo se admite el formato jpg o jpeg')
        } else {
          vm.selfie_image = window.URL.createObjectURL(user_image)
          const blob = await this.compressImage(user_image, parseInt(10));
          // alert('photo size ' + blob.size /1024)

          vm.loadUserImage(blob)
        }
      }
    },
    async createDocumentImage(event) {
      if (event.target.files.length > 0) {
        let vm = this
        let document_image = event.target.files[0]
        vm.document_image = window.URL.createObjectURL(document_image)
        const blob = await this.compressImage(document_image, parseInt(10));
        vm.loadDocumentImage(blob)
      }
    },
    loadUserImage(file) {
      let reader = new FileReader()
      let vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.mail.user_photo = reader.result
      }
    },
    loadDocumentImage(file) {
      let reader = new FileReader()
      let vm = this;
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.mail.document_photo = reader.result
      }
    },
    compressImage(imagenComoArchivo, porcentajeCalidad) {

      return new Promise((resolve, reject) => {
        const $canvas = document.createElement("canvas");
        const imagen = new Image();
        let oldWidth, oldHeight, newHeight, newWidth = 1000;

        imagen.onload = () => {
          oldWidth = imagen.width;
          oldHeight = imagen.height;
          newHeight = Math.floor(oldHeight / oldWidth * newWidth)
          $canvas.width = newWidth;
          $canvas.height = newHeight;
          $canvas.getContext("2d").drawImage(imagen, 0, 0, newWidth, newHeight);
          $canvas.toBlob(
            (blob) => {
              if (blob === null) {
                return reject(blob);
              } else {
                resolve(blob);
              }
            },
            "image/jpeg",
            porcentajeCalidad / 100
          );
        };
        imagen.src = URL.createObjectURL(imagenComoArchivo);
      });

    },
    handleCancel() {
      this.$emit('handleCancelModalRewardUser', false)
    },
    buildDeviceId() {
      let uuid
      if (localStorage.device_id !== undefined &&
        localStorage.device_id !== null &&
        localStorage.device_id !== '' &&
        localStorage.device_id !== 'null') {
        uuid = localStorage.device_id
      } else {
        uuid = this.$uuid.v1()
        localStorage.device_id = uuid
      }
      this.updateDeviceId(uuid);
      return uuid
    },
    clearFields() {
      this.mail = {
        rut: '',
        vehicle_type: '',
        plate_number: '',
        name: '',
        email: '',
        phone: '',
        location_id: '',
        document_photo: null,
        user_photo: null,
        sublocation_id: '',
        virtual_guard: true
      }
      this.show_errors = false
      this.selfie_image = null
      this.document_image = null
      this.current_company = this.$route.query.id ? this.$route.query.id : null
      this.mail.location_id = this.$route.query.location_id ? Number(this.$route.query.location_id) : null
      this.mail.sublocation_id = this.$route.query.sublocation_id ? Number(this.$route.query.sublocation_id) : null
      // if (this.current_company != null && (this.mail.location_id == null || this.mail.sublocation_id == null)) {
      //   this.open_access_request = false
      // }
      this.findLocationsByCompany()
    },
    requestAccess() {
      this.loader = true
      this.invalid_email = false

      try {
        this.$http.post(this.open_access_request ? 'app/users/open_external_access_request' : 'app/users/external_access_request', { data: this.encrypt({ attributes: this.mail }).toString() },)
          .then(function (response) {
            this.loader = false
            this.success = true;
          }, function (response) {
            this.loader = false
            let responseMsg = response.body.ans
            alert('Tu solicitud no pudo ser procesada, ' + responseMsg);
          })
      } catch (e) {
        this.loader = false
        console.error(e.message)
      }
    },
    validateVehicleTypeLocation() {
      if (this.locations.length > 0) {
        var selected_location = this.locations.find((loc) => loc.location_id === this.mail.location_id);
        if (selected_location !== undefined) {
          this.vehicular_type_location = selected_location.vehicular_type
          if (!this.vehicular_type_location) {
            this.mail.rut = ''
            this.mail.vehicle_type = ''
            this.mail.plate_number = ''
          }
        }
      }
    },
    close() {
      this.clearFields();
      this.success = false;
      this.startCamera();
    },
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'user' },
          audio: false,
        });
        this.$refs.video.srcObject = this.stream;
      } catch (e) {
        console.error(e);
      }
    },
    takePhoto() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.mail.user_photo = canvas.toDataURL('img/png');

      this.stopCamera();
    },

    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
    },
    removePhoto() {
      this.mail.user_photo = null;
      this.startCamera();
    }
  },
  beforeDestroy() {
    this.stopCamera();
  }
}
</script>
